import './configureLibraryMedia'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { configureClock } from '@plickers/now-player-library'
import { configureAnalytics } from '@plickers/now-player-library/player'
import App from './containers/AppContainer'
import store from './store'
import './styles/scss/App.scss'
import 'react-dates/lib/css/_datepicker.css'
import { createOnStorage } from './tabSyncMiddleware'
import { setupTabSyncBC } from './tabSyncMiddlewareBC'
import { calibratedCurrentTime } from './utils/calibratedCurrentTime'
import analytics from './utils/cdpAnalytics'

const onStorage = createOnStorage(store)
setupTabSyncBC(store)

// The shared library's scan countdown measures against the server's clock, not the
// projector's, the same way web's own code does through calibratedCurrentTime.
configureClock({ now: calibratedCurrentTime })

// The shared library's Live View media players track events (e.g. autoplay failed)
// through this sink; web's own copies called cdpAnalytics directly.
configureAnalytics({ track: analytics.track })

// listen to local storage events for new actions
window.addEventListener('storage', onStorage)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)
